import React from 'react';
import StartImg from '../../images/stert-2.svg'
function MarqueeSectionS2(props) {
    return (
        <section className="marquee-section fade_bottom">
            <div className="marquee_container">
                <div className="marquee">
                    <h2><img src={StartImg} alt="" /> branding</h2>
                    <h2><img src={StartImg} alt="" /> product design</h2>
                    <h2><img src={StartImg} alt="" /> digital marketing</h2>
                    <h2><img src={StartImg} alt="" /> product design</h2>
                    <h2><img src={StartImg} alt="" /> art direction</h2>
                    <h2><img src={StartImg} alt="" /> motion graphics</h2>

                </div>
                <div className="marquee">
                    <h2><img src={StartImg} alt="" /> strategy</h2>
                    <h2><img src={StartImg} alt="" /> product design</h2>
                    <h2><img src={StartImg} alt="" /> digital marketing</h2>
                    <h2><img src={StartImg} alt="" /> product design</h2>
                    <h2><img src={StartImg} alt="" /> art direction</h2>
                    <h2><img src={StartImg} alt="" /> development</h2>
                </div>
            </div>
        </section>
    );
}

export default MarqueeSectionS2;